import { isNearMeSlugCandidate } from '@/src/lib/seo/near-me';

const LEGACY_NO_APP_PREFETCH_PATHS = new Set(['/list-your-rental', '/pay-your-rent', '/about-us', '/directory-sitemap']);

function normalizeInternalPath(href: string): string {
  const path = href.split(/[?#]/, 1)[0] ?? href;
  const withoutTrailingSlash = path.length > 1 ? path.replace(/\/+$/, '') : path;

  return withoutTrailingSlash.replace(/^\/(?:en|es)(?=\/|$)/, '') || '/';
}

export function shouldDisableAppRouterPrefetch(href: string): boolean {
  if (!href.startsWith('/')) {
    return false;
  }

  const path = normalizeInternalPath(href);

  if (LEGACY_NO_APP_PREFETCH_PATHS.has(path)) {
    return true;
  }

  // All single-segment *-near-me URLs are middleware-rewritten, geolocation-dependent
  // pages — suffix match so new registry slugs are covered without maintaining a list.
  const [, segment, ...rest] = path.split('/');
  return rest.length === 0 && segment !== undefined && isNearMeSlugCandidate(segment);
}
